/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyVersionModel } from '../../models/client-survey-version-model';

export interface GetSurveyVersionById$Plain$Params {

/**
 * id of surveyversion for filter
 */
  surveyVersionId: number;
}

export function getSurveyVersionById$Plain(http: HttpClient, rootUrl: string, params: GetSurveyVersionById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
  const rb = new RequestBuilder(rootUrl, getSurveyVersionById$Plain.PATH, 'get');
  if (params) {
    rb.path('surveyVersionId', params.surveyVersionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyVersionModel>;
    })
  );
}

getSurveyVersionById$Plain.PATH = '/api/SurveyVersion/{surveyVersionId}';
